import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es/common.json';
import en from './locales/en/common.json';
import pt from './locales/pt/common.json';

function storedLanguage(): string | null {
  try {
    return globalThis.localStorage?.getItem('language') ?? null;
  } catch {
    return null;
  }
}

i18n.use(initReactI18next).init({
  resources: {
    es: { common: es },
    en: { common: en },
    pt: { common: pt },
  },
  ns: ['common'],
  defaultNS: 'common',
  lng: storedLanguage() || 'es',
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
